import React, { FunctionComponent, useCallback } from 'react';
import { filter, find, join, map } from 'ramda';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import CustomPopover from '../../../../components/CustomPopover';
import TeamList from '../../../../containers/TeamList';
import { ITeam } from '../../../../common/models/team/ITeam';
import { IBindingCallback1 } from '../../../../common/models/callback';
import Icon from '../../../../components/Icon';
import TextOverflowTooltip from '../../../../components/TextOverflowTooltip';
import { IAppState } from '../../../../common/models/store/IAppState';
import styles from './styles.module.scss';

interface IProps {
  selectedTeamIds: string[] | undefined;
  teams: ITeam[] | null;
  onChange: IBindingCallback1<string[] | undefined>;
}

const TeamFilter: FunctionComponent<IProps> = ({ selectedTeamIds, teams, onChange }) => {
  const selectedTeams = selectedTeamIds && teams && filter(
    ({ id }) => Boolean(find(selectedTeamId => selectedTeamId === id, selectedTeamIds)),
    teams
  );

  const Trigger = useCallback(() => {
    const content = selectedTeams
      ? join(', ', map(({ name }) => name, selectedTeams))
      : <FormattedMessage id="showAll" defaultMessage="Show all" />;
    return (
      <div className={`popup-trigger ${styles.trigger}`}>
        <TextOverflowTooltip content={content} width={200}>
          {content}
        </TextOverflowTooltip>
        <Icon icon="chevronDown" className="popup-chevron" />
      </div>
    );
  }, [teams, selectedTeamIds]);

  const onSelect = (newSelectedteams: ITeam[]) => {
    const newFilterVal = newSelectedteams?.length ? map(({ id }) => id, newSelectedteams) : undefined;
    onChange(newFilterVal);
  };

  const TeamListComponent = useCallback(() => (
    <TeamList
      selectedIds={selectedTeamIds}
      onSelect={onSelect}
      advanced
      multipleChoice
    />
  ), [selectedTeamIds]);

  return (
    <div className="popup-wrapper">
      <div className="popup-label">
        <FormattedMessage id="usersPane.teamFilter" defaultMessage="Filter by / manage teams" />
      </div>
      <CustomPopover
        popoverClassName={styles.teamPopover}
        placement="bottom-start"
        trigger={<Trigger />}
        rootClose
      >
        <TeamListComponent />
      </CustomPopover>
    </div>
  );
};

const mapStateToProps = ({
  teamList: { teams }
}: IAppState) => ({ teams });

export default connect(mapStateToProps)(TeamFilter);
